/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Frame_Forward_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Frame Forward" |
*
* @param {Player_Frame_Forward_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_frame_forward_aria_label = /** @type {((inputs?: Player_Frame_Forward_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Frame_Forward_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Image Suivante")
	if (locale === "de") return /** @type {LocalizedString} */ ("Frame Forward")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frame in avanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кадровое движение вперед")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marco hacia adelante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧前")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームフォワード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम आगे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro frontal")
	return /** @type {LocalizedString} */ ("Frame Forward")
});